import { render, staticRenderFns } from "./auth-text.vue?vue&type=template&id=1b56e5a5&scoped=true&"
import script from "./auth-text.vue?vue&type=script&lang=js&"
export * from "./auth-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56e5a5",
  null
  
)

export default component.exports